import axios from "axios";
import { create } from "zustand";

const paymentStore = create((set) => ({
  mPaymentDetails: null,
  paymentDetails: null,
  isLoading: true,

  fetchAllPayment: async () => {
    try {
      // Fetch payment
      const res = await axios.get("/fetch-all-payment");

      // set payment to state
      if (res.data.paymentDetail.length) {
        set({
          mPaymentDetails: res.data.paymentDetail,
          paymentDetails: res.data.paymentDetail,
        });
      } else {
        set({ mPaymentDetails: null, paymentDetails: null });
      }
      set({ isLoading: false });
    } catch (error) {
      console.log(error);
    }
  },

  createAndUpdatePaymentForReturn: async ({
    createPaymentData,
    updatePaymentData,
    paymentID,
  }) => {
    try {
      set({ isLoading: true });

      const resCreate = await axios.post(
        "/create-payment-for-return",
        createPaymentData
      );

      if (resCreate) {
        const newPaymentID = resCreate.data.paymentDetail._id;

        const resUpdate = await axios.put(
          `/update-payment-for-return/${paymentID}`,
          updatePaymentData
        );

        set({
          mPaymentDetails: resUpdate.data.paymentDetail,
          paymentDetails: resUpdate.data.paymentDetail,
        });

        set({ isLoading: false });
        return newPaymentID;
      } else {
        set({ isLoading: false });
        return null;
      }
    } catch (error) {
      set({ isLoading: false });
      console.log(error);
    }
  },
}));

export default paymentStore;
